import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import Question from './Question';
import QuestionModification from './QuestionModification';
/**
 * Renders a preview of a generated survey object.
 */
const SurveyPreview = ({
  survey: {
    surveyTitle,
    questions
  },
  revisionState
}) => {
  return _jsxs(_Fragment, {
    children: [_jsx(Typography, {
      variant: "pageTitle",
      color: "dark",
      weight: "light",
      children: surveyTitle
    }), revisionState.variant === 'proposed' || revisionState.variant === 'accepted' ? revisionState.difference.map(({
      action,
      index,
      item
    }) => _jsx(Box, {
      children: _jsx(QuestionModification, {
        modifiedQuestion: {
          action,
          index,
          item
        },
        variant: revisionState.variant,
        children: _jsx(Question, {
          question: item,
          questionNumber: index + 1
        })
      })
    }, item.title)) : questions.map((question, index) => _jsx(Box, {
      mt: 6,
      children: _jsx(Question, {
        question: question,
        questionNumber: index + 1
      })
    }, question.title))]
  });
};
export default SurveyPreview;